<template>
<div class="chapter">
<div class="inner_page">
<p class="p3">This book is dedicated to young Martin Andrews, who somehow found the courage to ask the love of his life, handsome Calvin Medford, to his senior prom. This book is also dedicated to Martin’s parents, Joyce and Ken, who thought nothing of it.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?a8c5dc88